import React from "react";
import { Palette, Factory, Package, Truck, Sparkles } from "lucide-react";

const STEPS = [
  {
    n: "01",
    title: "Design & Approval",
    body: "Share your logo or brief. Our studio sends a polished digital mockup within 24 hours for your sign-off.",
    icon: Palette,
  },
  {
    n: "02",
    title: "Quality Production",
    body: "Triple-filtered purified water, food-grade BPA-free 500ml PET, hi-res print labels — built to look premium.",
    icon: Factory,
  },
  {
    n: "03",
    title: "Packing & Palletizing",
    body: "24 bottles per case, 72 cases per skid (1,728 bottles). Wrapped, labeled and stacked for safe transit.",
    icon: Package,
  },
  {
    n: "04",
    title: "Shipping Included",
    body: "We handle the logistics across the GTA and Canada. Your order arrives where and when you need it.",
    icon: Truck,
  },
  {
    n: "05",
    title: "Your Brand. Everywhere.",
    body: "Recall, reach and results — one sip at a time. Plus a live analytics dashboard if you opted in for QR.",
    icon: Sparkles,
  },
];

export const HowWeWork = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-24 sm:py-32 bg-[var(--tq-bg-3)]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-16 max-w-3xl">
          <div className="overline mb-4">How We Work</div>
          <h2 className="font-display text-4xl sm:text-6xl font-black tracking-tighter leading-[0.92]">
            From brief to billboard
            <br />
            <span className="font-editorial italic font-medium">
              in five steps.
            </span>
          </h2>
        </div>

        <div className="relative">
          {/* Connector line */}
          <div className="hidden lg:block absolute top-12 left-0 right-0 h-px bg-slate-300" />

          <div className="grid lg:grid-cols-5 gap-6">
            {STEPS.map((s, i) => {
              const Icon = s.icon;
              return (
                <div
                  key={s.n}
                  data-testid={`step-${s.n}`}
                  className="relative bg-white rounded-2xl p-6 border border-slate-200 card-lift"
                >
                  <div className="relative mb-6">
                    <div className="w-16 h-16 rounded-full bg-[var(--tq-navy)] text-white flex items-center justify-center font-editorial text-2xl font-bold">
                      {s.n}
                    </div>
                    <div className="absolute -bottom-1 -right-1 w-7 h-7 rounded-full bg-white border-2 border-[var(--tq-navy)] flex items-center justify-center text-[var(--tq-navy)]">
                      <Icon size={14} />
                    </div>
                  </div>
                  <h3 className="font-display text-lg font-bold tracking-tight mb-2">
                    {s.title}
                  </h3>
                  <p className="text-sm text-slate-600 leading-relaxed">{s.body}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Specs */}
        <div className="mt-16 grid grid-cols-2 sm:grid-cols-4 gap-4">
          {[
            ["500ml", "PET Plastic Bottle"],
            ["BPA Free", "Food-Grade Safe"],
            ["100%", "Recyclable"],
            ["1,728", "Bottles per skid"],
          ].map(([v, l]) => (
            <div
              key={l}
              className="bg-white rounded-2xl p-6 border border-slate-200 text-center"
            >
              <div className="font-display text-2xl font-black tracking-tighter">
                {v}
              </div>
              <div className="font-mono text-[10px] uppercase tracking-widest text-slate-500 mt-2">
                {l}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
